import { Component, Input, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy, booleanAttribute } from '@angular/core';
import { Notification, NotificationType } from '../../store';
import { Store } from '@ngrx/store';
import moment from 'moment';
import * as fromNotifications from '../../store';
import * as fromCop from 'src/app/modules/cop/store/cop';
import { UserContextService } from 'src/app/modules/core/services/user-context.service';
import { DistanceService } from 'src/app/modules/core/services/distance/distance.service';
import { DataFormattingService } from 'src/app/modules/cop/services/format/data-formatting.service';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_APP_CULTURE_CODE } from 'src/app/modules/core/languages/language.model';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { NotificationApiService } from '../../store/notification-api.service';
import * as fromComm from 'src/app/modules/communications/store/communications';
import { MassNotification } from 'src/app/modules/communications/store/communications';
import * as fromRouting from 'src/app/modules/core/store/routing';

@Component({
    selector: 'topo-notification-display',
    templateUrl: './notification-display.component.html',
    styleUrls: ['./notification-display.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotificationDisplayComponent {
  NotificationType = NotificationType;

  fromIcon: string;
  fromName: string;
  name: string;
  recipientName: string;
  notificationUId: string;
  distance: string;
  message: string;
  subject: string;
  location: string;
  dateSentFormatted: string;
  dateSentElapsedTime: string;
  uId: string;
  markRead: boolean = false;
  defaultCultureCode = DEFAULT_APP_CULTURE_CODE;
  isTransient: boolean;
  soundUrl: string;
  showDefaultIcon: boolean = false;
  @Input() showBorder = false;
  datasetUId: string;
  documentUId: string;
  messageType: NotificationType;
  escalatedMessage: string;
  @Input() canZoomToDocument = false;

  @Input()
  set notification(value: Notification) {
    const cultureCode = this.cultureService.currentLang;
    const translation =
      value.translations.find(t => t.cultureCode === cultureCode) ??
      value.translations.find(t => t.cultureCode === this.defaultCultureCode) ??
      value.translations[0];

    this.uId = value.uId;
    this.fromIcon = value.fromIcon;
    this.fromName = value.fromName;
    this.distance = !isNaN(value.distance) && value.distance >= 0 ? this.distanceService.parseToFriendlyDistance(value.distance) : null;
    this.subject = translation.subject;
    this.message = translation.message;
    this.location = translation.location;
    if (!this.location && value.geometry) {
      this.location = this.dataFormattingService.getLatLngForDisplay(value.geometry);
    }
    this.dateSentFormatted = this.cultureService.getDateDisplay(moment(value.dateSent), 'LONG-DATE-WITH-TIME');
    this.dateSentElapsedTime = moment(value.dateSent).from(new Date());
    this.isTransient = value.isTransient;
    this.soundUrl = value.soundUrl;
    this.datasetUId = value.datasetUId;
    this.documentUId = value.documentUId;
    this.messageType = value.messageType;

    this.name = null;
    this.recipientName = null;
    this.notificationUId = null;
    this.escalatedMessage = null;

    if (this.messageType == NotificationType.MassCommunication && !!this.fromName) {
      try {
        const fromData = JSON.parse(this.fromName);
        this.notificationUId = fromData.notificationUId;
        this.name = fromData.name;
        this.recipientName = fromData.recipientName;
      } catch (e) {}

      this.escalatedMessage = this.getEscalatedMessage();
    }
  }

  constructor(
    private store$: Store,
    private changeDetector: ChangeDetectorRef,
    private distanceService: DistanceService,
    private cultureService: CultureService,
    private dataFormattingService: DataFormattingService,
    private translateService: TranslateService
  ) {}

  iconLoad(e): void {
    if (e.type == 'error') {
      this.showDefaultIcon = true;
      this.changeDetector.detectChanges();
    }
  }

  private getEscalatedMessage(): string {
    return this.translateService.instant('NOTIFICATIONS.ESCALATED-MESSAGE', {
      name: this.name,
      channel: this.location,
      response: this.subject
    });
  }

  markReadClick(): void {
    this.store$.dispatch(fromNotifications.clearNotification({ uId: this.uId }));
  }

  zoomToDocument(): void {
    if (this.canZoomToDocument) {
      this.store$.dispatch(fromCop.zoomToDocumentByUIds({ datasetUId: this.datasetUId, documentUId: this.documentUId }));
    }
  }

  showSentMessage(): void {
    if (!!this.notificationUId) {
      const notification = {
        uId: this.notificationUId
      } as MassNotification;
      this.store$.dispatch(fromComm.reviewMassNotification({ notification: notification }));
    }

    this.changeDetector.markForCheck();
  }

  goToIncident() {
    this.store$.dispatch(
      fromRouting.go({
        routeData: { path: ['incidents', this.datasetUId, this.documentUId], extras: { onSameUrlNavigation: 'reload' } }
      })
    );
  }
}
